import React, { useState } from "react";
import ReactMarkdown from "react-markdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExpand, faMoon, faSun } from "@fortawesome/free-solid-svg-icons";

function Main({ activeNote, onUpdateNote, darkMode, setDarkMode }) {

    const [value, setValue] = useState(false);
    const [str, setStr] = useState("app-main-note-preview");

    const onEditField = (key, value) => {
        onUpdateNote({
            ...activeNote,
            [key]: value,
            lastModified: Date.now(),
        });
    };

    if (!activeNote) return <div className="no-active-note">No note selected</div>

    const handleClick = () => {
        if (value === true) {
            setValue(!value);

                setStr("app-main-note-preview")

        }
        else {
            console.log("false");
                setStr("app-main-note-preview fullScreen");
            
            setValue(!value);
        }
    }

    return (
        <div className={darkMode ? "app-main-dark": "app-main"}>
            <div className={darkMode ? "app-main-note-edit dark": "app-main-note-edit"}>
                <input type="text" id="title" value={activeNote.title} onChange={(e) => onEditField("title", e.target.value)} autoFocus />
                <textarea id="body" placeholder="Write your Notes here..." value={activeNote.body} onChange={(e) => onEditField("body", e.target.value)}></textarea>
            </div>
            <div className={darkMode ? `${str} dark`: str}>
                <h1 className="preview-title">{activeNote.title}</h1>
                <div className="expandP">
                <button onClick={() => setDarkMode(!darkMode)} className="toggleIcon">
                    {!darkMode && <FontAwesomeIcon icon={faMoon} />}
                    {darkMode && <FontAwesomeIcon icon={faSun} />}
                </button>
                <FontAwesomeIcon icon={faExpand} className="expand" onClick={handleClick} />
                </div>
                <ReactMarkdown className="markdown-preview">
                    {activeNote.body}
                </ReactMarkdown>
            </div>
        </div>
    )
}

export default Main;